var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCase = function SvgCase(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 13.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.908 3.062H1.83c-.68 0-1.23.55-1.23 1.23v7.385c0 .68.55 1.23 1.23 1.23h11.077c.68 0 1.23-.55 1.23-1.23V4.292c0-.68-.55-1.23-1.23-1.23M9.83 3.062V1.83A1.23 1.23 0 0 0 8.6.6H6.138a1.23 1.23 0 0 0-1.23 1.23v1.23M.6 7.985H14.14M10.446 8.908V7.062M4.292 8.908V7.062"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCase);
export default ForwardRef;